import { useContext } from "react";
import { StoreContext } from "../store/Store";
import { actionTypes } from "../store/storeTypes";
import Draggable from "react-draggable";
import Linkify from "linkify-react";

const closeStyle = {
  position: "absolute",
  height: 15,
  width: 15,
  right: 10,
  top: 10,
  zIndex: 10,
  cursor: "pointer",
};

export const Popup = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { popup, flowConfig } = store;

  const parentStyle = {
    position: "absolute",
    width: flowConfig.popupWidth,
    borderRadius: flowConfig.popupBorderRadius,
    backgroundColor: flowConfig.popupBackgroundColor,
    top: 50,
    right: 50,
    border: `${flowConfig.popupBorderWidth}px solid ${flowConfig.popupBorderColor}`,
    zIndex: 9,
  };

  const popupStyle = {
    padding: flowConfig.popupPadding,
    fontSize: flowConfig.popupFontSize,
    fontWeight: flowConfig.popupFontWeight,
    color: flowConfig.popupFontColor,
    lineHeight: flowConfig.popupLineHeight / 10,
  };

  const CloseButton = () => {
    return (
      <div style={closeStyle} onClick={() => onClose()}>
        x
      </div>
    );
  };

  const Content = ({ content }) => {
    const options = {
      target: "_blank",
    };
    return (
      <Linkify as="p" options={options}>
        <>{content}</>
      </Linkify>
    );
  };

  const onClose = () => {
    dispatch({
      type: actionTypes.SET_POPUP,
      payload: { active: false, content: "" },
    });
  };
  return popup.active ? (
    <Draggable>
      <div style={parentStyle}>
        <CloseButton />
        <div style={popupStyle}>
          <Content content={popup.content} />
        </div>
      </div>
    </Draggable>
  ) : null;
};
